<section>
  <div>
    <slot />
  </div>
</section>

<style>
  section {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
      Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }

  div {
    background: var(--loop-background);
    color: var(--loop-foreground);
    position: relative;
    max-height: calc(100vh - 50px);
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 165px;
  }
</style>
